__turbopack_context__.v({
  "accountPopover": "MenuFlyout-module-scss-module__yLRnYq__accountPopover" + " " + "MenuFlyout-module-scss-module__yLRnYq__popOver",
  "helpPopover": "MenuFlyout-module-scss-module__yLRnYq__helpPopover" + " " + "MenuFlyout-module-scss-module__yLRnYq__popOver",
  "hiddenArrow": "MenuFlyout-module-scss-module__yLRnYq__hiddenArrow",
  "popOver": "MenuFlyout-module-scss-module__yLRnYq__popOver",
  "popperArrow": "MenuFlyout-module-scss-module__yLRnYq__popperArrow",
  "transitionStyles": "MenuFlyout-module-scss-module__yLRnYq__transitionStyles",
});
